module.exports = __webpack_public_path__ + "b056e4cb24ae9f73b891cf094928f323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-8.jpg
// module id = 397
// module chunks = 0